import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import timezonesFull from './timezones.json';
import timezonesReduced from './timezones_reduced.json';

function CrowFieldCustomCommonDateTimezone(props) {
	const {
		entity,
	} = props;
	let {
		value,
	} = props;
	let {
		attr = {},
	} = entity || {};
	let {
		htmlattr,
	} = attr || {};

	let options = [];

	timezonesReduced.forEach((entry) => {
		(entry.utc || []).forEach((timezone) => {
			let parts = timezone.split('/');
			let city = parts[parts.length - 1] || timezone;
			city = city.replace(/_/g, ' ');

			let shortValue = (entry.value || '').replace(/( Standard Time| Daylight Time| Standard| Daylight| Time)$/, '').trim();

			let tz = {
				'label': `${city} (${entry.abbr} - ${shortValue})`,
				'value': timezone,
			};

			options.push(tz);

			// If props.value matches timezone, set to react-select object format
			if (value && value === timezone) {
				value = tz;
			}
		});
	});

	let incomingValue = value;
	if (incomingValue && typeof incomingValue === 'object' && 'value' in incomingValue) {
		incomingValue = incomingValue.value;
	}

	const foundInReduced = options.find((o) => o.value === incomingValue);
	if (!foundInReduced && incomingValue) {
		let oldEntry = null;
		for (const entry of timezonesFull) {
			if (entry.utc && entry.utc.includes(incomingValue)) {
				oldEntry = entry;
				break;
			}
			if (entry.value === incomingValue || entry.text === incomingValue) {
				oldEntry = entry;
				break;
			}
		}

		if (oldEntry) {
			let city = null;
			if (Array.isArray(oldEntry.utc) && oldEntry.utc.length) {
				const tzCandidate = oldEntry.utc.find(tz => typeof tz === 'string' && tz.includes('/')) || oldEntry.utc[0];
				if (tzCandidate) {
					city = tzCandidate.split('/').pop().replace(/_/g, ' ');
				}
			}
			if (!city) {
				let parts = (incomingValue || '').split('/');
				city = parts[parts.length - 1] || (oldEntry.text || incomingValue);
				if (typeof city === 'string') {
					city = city.replace(/_/g, ' ');
				}
			}

			let shortValue = (oldEntry.value || '').replace(/( Standard Time| Daylight Time| Standard| Daylight| Time)$/, '').trim();
			if (!shortValue && oldEntry.text) {
				shortValue = oldEntry.text.replace(/^\(UTC[^\)]+\)\s*/,'').split(',')[0];
			}

			const abbr = oldEntry.abbr || '';
			const oldLabel = `${city} (${abbr}${abbr ? ' - ' : ''}${shortValue})`;
			const oldOption = { label: oldLabel, value: incomingValue };

			options.unshift(oldOption);

			value = oldOption;
		} else {
		}
	} else if (foundInReduced) {
		value = foundInReduced;
	}

	const [selected, setSelected] = useState(value || null);
	useEffect(() => {
		setSelected(value || null);
	}, [incomingValue]);

	// Sort timezones alphabetically
	options.sort((a, b) => {
		if (a.label < b.label) {
			return -1;
		}
		if (a.label > b.label) {
			return 1;
		}
		return 0;
	});

	return (
		<div className={`text-small ${(props.classNameList || []).join(' ')}`}>
			<div className="label">
				<label>{entity.attr.label}</label>
			</div>
			<Select
				id={attr['data-test-id'] || attr.name}
				options={options}
				value={selected}
				onChange={(e) => {
					setSelected(e);
					props.app.setValue('todo', entity.name, e.value);
				}}
				{...htmlattr}
			/>
		</div>
	);
}

const _exports = {
	name:  'custom.common.date.timezone',
	desc:  'Standard Timezone Field',
	scope: {},
	field: CrowFieldCustomCommonDateTimezone,
};

export default _exports;